export const LoginIcon = () => (
  <svg height="61" viewBox="0 0 61 61" width="61" xmlns="http://www.w3.org/2000/svg">
    <g data-name="Group 8736" id="Group_8736" transform="translate(-354 -135)">
      <g data-name="Group 8490" id="Group_8490" transform="translate(-60.5 22.5)">
        <circle
          cx="30.5"
          cy="30.5"
          data-name="Ellipse 1"
          fill="#f2f2f2"
          id="Ellipse_1"
          r="30.5"
          transform="translate(414.5 112.5)"
        />
      </g>
      <g data-name="Group 8673" id="Group_8673" transform="translate(22224.357 13267.193)">
        <path
          d="M21.582,0c.209.056.421.105.627.169a3.673,3.673,0,0,1,2.578,3.342c.009.142.008.284.008.426q0,10.718.005,21.434a3.8,3.8,0,0,1-2.063,3.572c-2.429,1.374-4.833,2.792-7.261,4.169a3.647,3.647,0,0,1-5.487-3.245c.006-.522,0-1.044,0-1.61H9.568c-1.666,0-3.334.033-5-.019a3.605,3.605,0,0,1-3.558-3.613c-.032-1.356-.016-2.713,0-4.07a1.206,1.206,0,1,1,2.412.018c.007,1.3,0,2.6,0,3.906a1.267,1.267,0,0,0,1.367,1.377c1.633.005,3.267,0,4.9,0,.085,0,.17-.01.3-.019v-.429c0-5.12.015-10.242-.009-15.362a3.79,3.79,0,0,1,2.072-3.594c2.2-1.241,4.384-2.519,6.575-3.781a.919.919,0,0,0,.307-.26H4.875A1.274,1.274,0,0,0,3.423,3.858c0,1.455,0,2.91,0,4.365a1.207,1.207,0,0,1-1.54,1.226A1.137,1.137,0,0,1,1.021,8.4c-.015-1.717-.068-3.439.04-5.15A3.519,3.519,0,0,1,4.066.055.671.671,0,0,0,4.218,0H21.582Z"
          fill="#002649"
          id="VectorOne"
          transform="translate(-21850.102 -13117)"
        />
        <path
          d="M10.4,4.019c-.486-.481-.9-.891-1.319-1.3a1.166,1.166,0,0,1-.307-1.266A1.192,1.192,0,0,1,10.6.864a1.981,1.981,0,0,1,.247.216q1.606,1.6,3.209,3.2a1.21,1.21,0,0,1,0,1.874q-1.6,1.6-3.209,3.2a1.21,1.21,0,1,1-1.7-1.706c.37-.374.741-.744,1.112-1.118a.546.546,0,0,0,.049-.112H1.367a1.219,1.219,0,0,1-1.324-.9,1.19,1.19,0,0,1,1.093-1.5c.383-.018.767-.006,1.151-.006H10.4Z"
          fill="#ff7600"
          id="VectorOne-1"
          transform="translate(-21856.359 -13107.837)"
        />
      </g>
    </g>
  </svg>
);
